import landing from './media/images/landing.jpg';
import midLandingPage from './media/images/midLandingPage.jpg';
import bg from './media/images/landing2.jpg'
const topData = [
    {
        id:1,
        title:'Select a role to begin your journey',            
        tag:'How to do it?',
        button1:'Raidder',
        button2: 'Watcher',
        centeredText: true,
        image: landing
    },
    {
        id:2,
        title:'Watchers',
        subtitle:'A watcher volunteers for encouragement of the raidders participating and watching the raidlive events. Only the Watchers will be able to stream the entire RaidLive event live. The watchers will be anonymous for watching the live streams.',
        tag:'Who are watchers?',
        image: midLandingPage
    },
    {
        id:3,
        title:'Raidders',
        subtitle:'A raidder volunteers for participation in live tournaments. The raidders completing the rounds will be rewarded.A team of raidders will be selected randomly based on the profile they choose during the registration, so select wisely.',
        tag:'Who are raidders?',
        image: midLandingPage
    },
    {
        id:4,
        title:'Built on decentralized network',        
        subtitle:'A decentralized streaming platform where players and watchers raid side by side.',
        tag:'How is it unique?',
        image: bg
    }     
]

export default topData;